import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 10 17"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8.886 3.058A9 9 0 0 0 7.34 2.89c-1.11 0-1.182.482-1.182 1.252v1.372h2.775l-.242 2.842H6.16V17H2.684V8.356H.898V5.514h1.786V3.756C2.684 1.35 3.818 0 6.665 0c.99 0 1.714.145 2.655.337z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }